/**
 * @file Pricing Card
 */

import { gsap } from 'gsap';

/**
 * Pricing Card component
 */
const vPricingCard = () => {
	const pricingCards = document.querySelectorAll( '.v-pricing-card' );

	if ( ! pricingCards.length ) {
		return;
	}

	[ ...pricingCards ].forEach( ( card ) => {
		const toggle     = card.querySelector( '.v-pricing-card__toggle' );
		const toggleText = toggle.querySelector( '.v-pricing-card__toggle-text' );
		const body       = card.querySelector( '.v-pricing-card__body' );

		const cardCost  = card.querySelector( '.v-pricing-card__cost' );
		let isAnimating = false;

		toggle.addEventListener( 'click', ( e ) => {
			e.preventDefault();

			if ( isAnimating ) {
				return;
			}

			const detail = {
				target: card,
			};
			const tl     = gsap.timeline( {
				defaults: {
					ease: 'sine.out',
				},
				onStart: () => {
					isAnimating = true;
				},
				onComplete: () => {
					isAnimating = false;
					document.dispatchEvent( new CustomEvent( 'vPricingCardChange', { detail } ) );
				},
			} );

			if ( card.classList.contains( 'closed' ) ) {
				detail.action      = 'open';
				body.style.display = 'block';
				const targetHeight = body.getBoundingClientRect().height;

				gsap.set( body, { height: 0 } );

				tl.to( body, {
					height:     targetHeight,
					onComplete: () => {
						toggleText.textContent = toggle.getAttribute( 'data-open-text' );
						toggle.setAttribute( 'aria-expanded', 'true' );
						card.classList.remove( 'closed' );
						body.removeAttribute( 'style' );
					},
				} );
			} else {
				detail.action = 'close';

				tl.to( body, {
					height:     0,
					onComplete: () => {
						toggleText.textContent = toggle.getAttribute( 'data-close-text' );
						toggle.setAttribute( 'aria-expanded', 'false' );
						card.classList.add( 'closed' );
						body.removeAttribute( 'style' );
					},
				} );
			}
		} );

		// Listen for dd change event
		document.addEventListener( 'vReportsDropdownChange', ( { detail } ) => {
			const { target } = detail;

			if ( ! card.contains( target ) ) {
				return;
			}

			cardCost.textContent = detail.cost;
		} );
	} );
};

export default vPricingCard;
